import { defineMessages } from 'react-intl.macro';

export default defineMessages({
  serach: {
    id: '@lib.core.Select.search',
    defaultMessage: 'Searching',
  },
  noOptions: {
    id: '@lib.core.Select.noOptions',
    defaultMessage: 'No options',
  },
  placeholder: {
    id: '@lib.core.Select.placeholder',
    defaultMessage: 'Select',
  },
});
